<h1 class="border-gray border-bottom text-center pb-4 mb-5">System Errors</h1>
<div class="card border-0 bg-white shadow-sm mb-4">
	<div class="card-body p-xl-5">
		<div class="row">
			<div class="col-md-4 mb-1 mb-md-0">
				<input [(ngModel)]="params.searchText"
					(ngModelChange)="search()"
					type="text"
					placeholder="Free text search"
					class="form-control bordered">
			</div>
			<div class="col-md-4 col-lg-3 mb-1 mb-md-0">
				<ng-select [(ngModel)]="params.siteArea"
					[ngModelOptions]="{standalone: true}"
					[clearable]="false"
					[searchable]="false"
					(change)="search()"
					class="dark">
					<ng-option [value]="''">All site areas</ng-option>
					<ng-option *ngFor="let siteArea of siteAreas"
						[value]="siteArea">
						{{ siteArea }}
					</ng-option>
				</ng-select>
			</div>
			<div class="col-md-4 col-lg-3">
				<ng-select [(ngModel)]="params.errorType"
					[ngModelOptions]="{standalone: true}"
					[clearable]="false"
					[searchable]="false"
					(change)="search()"
					class="dark">
					<ng-option [value]="''">Error type</ng-option>
					<ng-option *ngFor="let errorType of errorTypes"
						[value]="errorType">
						{{ errorType }}
					</ng-option>
				</ng-select>
			</div>
		</div>
	</div>
</div>
<div class="card border-0 bg-white shadow-sm mb-4">
	<div class="card-body p-xl-5">
		<div class="table-responsive">
			<table class="table table-borderless align-middle custom-wrap">
				<thead class="thead-white">
					<tr>
						<th>Date</th>
						<th>User</th>
						<th>Area</th>
						<th>Type</th>
						<th>Description</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let error of (errors$ | async)"
						class="underlined">
						<td>
							{{error.createdAt | date: 'dd MMM yyyy @ HH:mm'}}
						</td>
						<td>
							<span *ngIf="error.firstname !== ''">
								{{error.firstname}} {{error.surname}}
							</span>
							<span *ngIf="error.firstname === ''">Unknown</span>
						</td>
						<td>{{error.siteArea}}</td>
						<td>{{error.errorType}}</td>
						<td>
							{{error.description}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="!(errors$ | async).length"
			class="no-results">
			<p>No errors to report</p>
		</div>
		<app-pagination *ngIf="params.pageArray.length"
			[params]="params"
			(update)="search()"></app-pagination>
	</div>
</div>
